/* Valyou instant search — attribute-aware search over a prebuilt index.
   The index (assets/valyou-search-index.json) carries its own lexicon, so this file
   never needs updating when the vocabulary changes; rebuild the index instead.
   Progressive enhancement: the header field is a real GET form to /search, so a
   failure here degrades to Shopify's own results page rather than breaking search. */
(function () {
  'use strict';
  if (window.__valyouSearch) return;
  window.__valyouSearch = true;

  var CDN = '//valyouhawaii.com/cdn/shop/files/';
  var IDX = null, LOADING = null, P = [];
  var active = { color: null, type: null, room: null, material: null, feature: null };
  var MODE = 'smart';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { return '$' + Number(n).toLocaleString('en-US'); }
  function norm(s) { return String(s || '').toLowerCase()
    .replace(/(\d),(?=\d{3}\b)/g, '$1').replace(/[’'`]/g, '')
    .replace(/[^a-z0-9$ ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function img(name, w) {
    if (!name) return '';
    var parts = name.split('?');
    return CDN + parts[0] + '?' + (parts[1] ? parts[1] + '&' : '') + 'width=' + w;
  }
  function srcset(name, widths) {
    return widths.map(function (w) { return img(name, w) + ' ' + w + 'w'; }).join(', ');
  }

  /* ---------- index ---------- */
  function load() {
    if (IDX) return Promise.resolve(IDX);
    if (LOADING) return LOADING;
    var url = (window.VALYOU_SEARCH_INDEX_URL || '/apps/none');
    LOADING = fetch(url, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.json(); })
      .then(function (d) {
        // Staleness guard. The index is a static asset; prices and stock are a snapshot.
        // Past the limit we refuse to serve it, and the UI falls back to Shopify's /search
        // rather than quoting figures we can no longer stand behind.
        var MAX_AGE_DAYS = 3;
        var age = d.built ? (Date.now() - Date.parse(d.built)) / 86400000 : 999;
        if (!(age < MAX_AGE_DAYS)) {
          var e = new Error('index stale: ' + Math.round(age) + 'd old');
          e.stale = true;
          throw e;
        }
        IDX = d;
        P = d.products.map(function (a) {
          var instockIdx = -1;
          for (var q = 0; q < d.feats.length; q++) if (d.feats[q][0] === 'instock') instockIdx = q;
          return { h: a[0], t: a[1], ty: a[2], min: a[3], max: a[4], c: a[5], m: a[6],
                   r: a[7], f: a[8], img: a[9], rt: a[10], nr: a[11], pre: a[12],
                   w: a[13], tok: ' ' + a[14] + ' ', ci: a[15], _t: ' ' + norm(a[1]) + ' ',
                   buyable: a[12] === 1 || a[8].indexOf(instockIdx) > -1 };
        });
        return d;
      });
    LOADING.catch(function () { LOADING = null; });   // let the next open retry
    return LOADING;
  }
  var K = {
    color: function (i) { return IDX.colors[i]; },
    type:  function (i) { return IDX.types[i]; }
  };
  function keyIndex(list, k) { for (var i = 0; i < list.length; i++) if (list[i][0] === k) return i; return -1; }

  /* ---------- query understanding ---------- */
  function parse(raw) {
    // Prices are read off the RAW string first: norm() strips '.' and '-', which would
    // turn "$2.5k" into "2 5k" and "$1,500-2,000" into "1500 2000".
    var rawLower = ' ' + String(raw || '').toLowerCase().replace(/,(?=\d{3}\b)/g, '') + ' ';
    var money0 = null, money1 = null;
    var mm = /(?:under|below|less than|up to|max|budget|cheaper than)\s*\$?\s*([\d.]+)\s*(k?)/.exec(rawLower);
    if (mm) money1 = Math.round(parseFloat(mm[1]) * (mm[2] ? 1000 : 1));
    var mn = /(?:over|above|more than|at least)\s*\$?\s*([\d.]+)\s*(k?)/.exec(rawLower);
    if (mn) money0 = Math.round(parseFloat(mn[1]) * (mn[2] ? 1000 : 1));
    var mr = /\$?\s*([\d.]+)\s*(k?)\s*(?:-|–|to)\s*\$?\s*([\d.]+)\s*(k?)/.exec(rawLower);
    if (mr) { money0 = Math.round(parseFloat(mr[1]) * (mr[2] ? 1000 : 1));
              money1 = Math.round(parseFloat(mr[3]) * (mr[4] ? 1000 : 1)); }
    if (money1 == null) {                      // a bare 3-4 digit number reads as a budget
      var mb = /(?:^|\s)\$\s*([\d.]+)(?:\s|$)/.exec(rawLower) || /(?:^|\s)(\d{3,5})(?:\s|$)/.exec(rawLower);
      if (mb && !/seat|person|people|inch|"/.test(rawLower)) money1 = Math.round(parseFloat(mb[1]));
    }
    if (money1 != null && money1 < 50) money1 = money1 * 1000;   // "under 2" means $2,000
    if (money0 != null && money0 < 50) money0 = money0 * 1000;

    var q = ' ' + norm(raw) + ' ';
    var out = { colors: [], types: [], rooms: [], mats: [], feats: [], unstocked: [],
                max: null, min: null, seats: null, rest: [] };
    function eat(w) {
      // allow a trailing plural on the LAST word, so 'ottoman' also matches 'ottomans'
      // and 'dining table' matches 'dining tables'. 26 of 27 common furniture plurals
      // returned zero before this.
      var esc = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var re = new RegExp('\\s' + esc + '(?:es|s)?\\s');
      if (re.test(q)) { q = q.replace(re, ' '); return true; } return false;
    }
    out.min = money0; out.max = money1;
    // strip the price words from the token stream so they do not survive into `rest`
    q = q.replace(/\s(?:under|below|less than|up to|max|budget|cheaper than|over|above|more than|at least|to)\s+\$?\s*[\d]+\s*k?\s/g, ' ')
         .replace(/\s\$\s*[\d]+\s*k?\s/g, ' ');
    if (out.max != null) q = q.replace(new RegExp('\\s\\$?' + out.max + '\\s'), ' ')
                              .replace(new RegExp('\\s\\$?' + Math.round(out.max / 1000) + '\\s*k?\\s'), ' ');
    if (out.min != null) q = q.replace(new RegExp('\\s\\$?' + out.min + '\\s'), ' ');
    if (eat('cheap') || eat('affordable')) out.max = out.max || 800;
    var m = /\s(?:seats?|sits?|fits?)\s*(\d+)\s/.exec(q) || /\s(\d+)\s*(?:seater|seat|person|people)\s/.exec(q);
    if (m) { out.seats = parseInt(m[1], 10); q = q.replace(m[0], ' '); }

    // one longest-match pass, so "light wood" beats "light", "accent chair" beats "chair"
    IDX.words.forEach(function (row) {
      if (!eat(row[0])) return;
      var b = out[row[1]];
      if (b.indexOf(row[2]) === -1) b.push(row[2]);
    });
    IDX.unstocked.forEach(function (row) { if (eat(row[0])) out.unstocked.push(row[0]); });

    var STOP = ' a an the for with and or of in on to my me i some something need want looking that is are it we our new good nice best really very would like can you have has do does get around about this be at from by as but so if all any one just only room space there ';
    out.rest = q.split(' ').filter(function (t) {
      return t && t.length > 1 && STOP.indexOf(' ' + t + ' ') === -1;
    });
    return out;
  }

  /* ---------- retrieval ---------- */
  function search(f) {
    var F = {
      colors: active.color ? [active.color] : f.colors,
      types:  active.type ? [active.type] : f.types,
      rooms:  active.room ? [active.room] : f.rooms,
      mats:   active.material ? [active.material] : f.mats,
      feats:  active.feature ? [active.feature] : f.feats,
      max: f.max, min: f.min, seats: f.seats, rest: f.rest, unstocked: f.unstocked
    };
    if (F.unstocked.length) return { hits: [], f: F, relaxed: [], blocked: F.unstocked[0] };

    var ci = F.colors.map(function (k) { return keyIndex(IDX.colors, k); });
    // expand each requested type over its narrower kin, keeping the exact ones for ranking
    var exactTypes = F.types.slice();
    var wantTypes = [];
    F.types.forEach(function (k) {
      var kin = (IDX.broaden && IDX.broaden[k]) || [k];
      kin.forEach(function (x) { if (wantTypes.indexOf(x) === -1) wantTypes.push(x); });
      if (wantTypes.indexOf(k) === -1) wantTypes.push(k);
    });
    var ti = wantTypes.map(function (k) { return keyIndex(IDX.types, k); }).filter(function (n) { return n > -1; });
    var tiExact = exactTypes.map(function (k) { return keyIndex(IDX.types, k); }).filter(function (n) { return n > -1; });
    var ri = F.rooms .map(function (k) { return keyIndex(IDX.rooms,  k); });
    var mi = F.mats  .map(function (k) { return keyIndex(IDX.mats,   k); });
    var fi = F.feats .map(function (k) { return keyIndex(IDX.feats,  k); });

    // Tokens that match nothing anywhere in the catalogue are noise, not intent.
    // Filtering on them wiped the whole result set; we drop them and say so instead.
    var deadTokens = [];
    var liveRest = F.rest.filter(function (t) {
      var alive = P.some(function (p) { return p._t.indexOf(t) > -1 || p.tok.indexOf(t) > -1; });
      if (!alive) deadTokens.push(t);
      return alive;
    });

    var structuredEarly = ci.length || ti.length || ri.length || mi.length || fi.length ||
                          F.max != null || F.min != null || F.seats != null;
    if (!structuredEarly && !liveRest.length && deadTokens.length) {
      // every word was noise and there is nothing else to go on — say so
      return { hits: [], f: F, relaxed: [], dead: deadTokens };
    }

    function apply(drop) {
      var on = function (k) { return drop.indexOf(k) === -1; };
      var r = P;
      if (ci.length && on('color')) r = r.filter(function (p) { return ci.some(function (x) { return p.c.indexOf(x) > -1; }); });
      if (ti.length && on('type'))  r = r.filter(function (p) { return ti.indexOf(p.ty) > -1; });
      if (ri.length && on('room'))  r = r.filter(function (p) { return ri.some(function (x) { return p.r.indexOf(x) > -1; }); });
      if (mi.length && on('material')) r = r.filter(function (p) { return mi.every(function (x) { return p.m.indexOf(x) > -1; }); });
      if (fi.length && on('feature'))  r = r.filter(function (p) { return fi.every(function (x) { return p.f.indexOf(x) > -1; }); });
      // index prices are integer CENTS; the parsed budget is dollars
      if (F.max != null && on('price')) r = r.filter(function (p) { return p.min <= F.max * 100; });
      if (F.min != null && on('price')) r = r.filter(function (p) { return p.max >= F.min * 100; });
      // width 0 means "unknown", not "narrow" — 142 of 267 products have no parseable width,
      // so excluding them made the seat filter unusable. Unknown is included, not dropped.
      if (F.seats != null && on('seats')) r = r.filter(function (p) { return !p.w || p.w < 24 || Math.round(p.w / 30) >= F.seats; });

      var phrase = liveRest.join(' ');
      var scored = r.map(function (p) {
        var s = 0;
        if (phrase && p._t.indexOf(' ' + phrase + ' ') > -1) s += 12;   // whole query in the title
        if (tiExact.length && tiExact.indexOf(p.ty) > -1) s += 3;        // exact type over expanded kin
        liveRest.forEach(function (t) {
          if (p._t.indexOf(' ' + t + ' ') > -1) s += 5;
          else if (p._t.indexOf(t) > -1) s += 3;
          else if (p.tok.indexOf(' ' + t + ' ') > -1) s += 2;
          else if (p.tok.indexOf(t) > -1) s += 0.5;
        });
        return { p: p, s: s };
      });
      if (liveRest.length && on('text')) scored = scored.filter(function (x) { return x.s > 0; });
      return scored;
    }

    var structured = ci.length || ti.length || ri.length || mi.length || fi.length ||
                     F.max != null || F.min != null || F.seats != null;
    var ORDER = ['room', 'feature', 'seats', 'material', 'price', 'text'];
    var has = { room: ri.length, feature: fi.length, seats: F.seats != null,
                material: mi.length, price: (F.max != null || F.min != null),
                // never relax the text filter on a pure text query — that would return
                // the entire catalogue for a typo instead of an honest zero
                text: liveRest.length && structured };
    var drop = [], scored = apply(drop);
    for (var i = 0; scored.length === 0 && i < ORDER.length; i++) {
      if (!has[ORDER[i]]) continue;
      drop = drop.concat(ORDER[i]);
      scored = apply(drop);
    }
    if (!scored.length) return { hits: [], f: F, relaxed: drop, dead: deadTokens };
    // Relevance is primary; the rating/in-stock bonus only breaks ties between equal
    // text scores. The old code sorted on the bonus alone, which buried 25% of products
    // below other products when you searched their exact name.
    scored = scored.map(function (x, i) {
      var sold = !x.p.buyable;
      return { p: x.p, s: x.s, i: i,
               b: (x.p.rt ? x.p.rt / 100 : 0) + (x.p.pre ? 0.06 : 0.12) - (sold ? 0.5 : 0) };
    }).sort(function (a, b) { return (b.s - a.s) || (b.b - a.b) || (a.i - b.i); });
    return { hits: scored.map(function (x) { return x.p; }), f: F, relaxed: drop, dead: deadTokens };
  }
  window.ValyouSearch = { load: load, parse: parse, search: search,
    get index() { return IDX; }, get products() { return P; },
    get active() { return active; }, setMode: function (m) { MODE = m; }, get mode() { return MODE; } };
})();
